import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import '../Branches.css';
import BranchFAB from '../components/BranchFAB';
import BranchInfo from '../components/BranchInfo';
import BranchGoogleMaps from './BranchGoogleMaps';

import { basicMsg } from '../../../../actions/swal_msg';
import { getPostalcodeData } from '../../../../actions/checkout';
import { saveBranchMainImage } from '../../../../actions/admin/branch';

import { FieldValues } from '../../../../helpers/admin/branch/branch';
import { form1Validator } from '../../../../validators/Admin/Branch/BranchValidator';

//MUI
import {
    Box, Button, Container, Divider, FormControl,
    FormHelperText, Grid, MenuItem, TextField,
    Typography, Link
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import LoadingButton from '@mui/lab/LoadingButton';
import { styled } from "@mui/material/styles";

import { BRANCH_FIELD_ERR, BRANCH_INIT} from '../../../../constants/admin/branch_constants';
import { GOOGLE_DRIVE_CDN, NO_IMG, CHECKOUT_DISABLED_INPUT } from '../../../../constants/constants';
import BranchSnackbar from '../components/BranchSnackbar';

const ButtonGreen = styled(Button)(({ theme }) => ({
    color: '#fff',
    backgroundColor: '#56C596',
    paddingLeft: '20px',
    paddingRight: '20px',
    fontWeight: '600',
    textTransform: 'none',
    '&:hover': {
        backgroundColor: '#358f69',
        color: '#fff'
    }
}));

const helperText = 'Ingrese colonia de la sucursal';

const NewBranch = () => {
    const navigate = useNavigate();
    const [values, setValues] = useState(BRANCH_INIT);
    const [inputErr, setInputErr] = useState(BRANCH_FIELD_ERR);

    const [open, setOpen] = useState(false);
    // botón al presionar guardar
    const [loading, setLoading] = useState(false);
    // campo a mostrar para colonia (select/field)
    const [fieldType, setFieldType] = useState('select');

    const {
        address, postalCode, colony, city, state,
        links: { whatsapp: { number, message }, facebook: { url } }
    } = values;

    const {
        address_err, pc_err, colony_err, city_err, state_err,
        wsp_number_err, wsp_message_err,
        // facebook_url_err,
    } = inputErr;

    const name_ref = useRef();
    const phone_ref = useRef();
    const email_ref = useRef();
    const address_ref = useRef();
    const postalCode_ref = useRef();
    const city_ref = useRef();
    const state_ref = useRef();
    const wsp_number_ref = useRef();
    const wsp_message_ref = useRef();
    const facebook_url_ref = useRef();
    const place_id_ref = useRef();

    const sharedRefs = {
        name_ref, phone_ref, email_ref, address_ref, postalCode_ref,
        city_ref, state_ref, wsp_message_ref, wsp_number_ref, facebook_url_ref,
        place_id_ref
    };

    // información recuperada con el código postal
    const [colonies, setColonies] = useState([]);

    // deshabilitación de campos
    const [disabledFields, setDisabledFields] = useState(CHECKOUT_DISABLED_INPUT);
    const { cityInput, stateInput } = disabledFields;

    const handlePlaceAutofill = () => {
        setColonies([]);
        setFieldType('field');
        setDisabledFields(current => ({
            ...current,
            cityInput: false,
            stateInput: false
        }));
    };

    const inputChange = ({ target: { name, value } }) => {
        FieldValues({ name, value }, setValues, { inputErr, setInputErr });
    };

    // campo pierde foco
    const handleInputBlur = async ({ target }) => {
        // busca información del CP ingresado
        if (target.name === 'postalCode') {
            const resp = await getPostalcodeData(postalCode);
            if (resp.status) {
                const { resp: { municipio, estado, asentamiento } } = resp;
                setValues({
                    ...values,
                    colony: '',
                    city: municipio,
                    state: estado
                });
                setColonies(asentamiento);
                setDisabledFields({
                    ...disabledFields,
                    cityInput: true, stateInput: true
                });
            } else {
                setColonies([]);
                setDisabledFields({
                    ...disabledFields,
                    cityInput: false, stateInput: false
                });
            }
        }
    };

    // imagen principal de sucursal
    const [file, setFile] = useState("");
    const handleChange = ({ target }) => {
        if (target.files.length > 0) {
            const ImgFile = target.files[0];
            if (['image/jpeg', 'image/png', 'image/webp'].includes(ImgFile.type))
                setFile(ImgFile);
            else basicMsg('Imagen no compatible');
        }
    };
    
    // envío de formulario
    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        // validación del formulario
        if (form1Validator({ ...values, file }, sharedRefs, 'save', setInputErr)) {
            if (await saveBranchMainImage({ ...values, file })) {
                navigate('/nefro-admin/sucursales');
                return;
            }
        }
        setLoading(false);
    };

    const showAvailableFields = () => {
        if (colonies.length <= 0) {
            if (!open) setOpen(true);
            return;
        }
        setFieldType('select');
    };

    return (
        <>
            <Container maxWidth='xl' sx={{ mb: 5 }} style={{ marginTop: '90px' }}>
                <Typography variant='h5' paragraph>Crear nueva sucursal</Typography>
                <Box sx={{ p: 3, boxShadow: '0 2px 4px 2px rgb(0 0 0 / 20%)', borderRadius: '6px', bgcolor: '#fff' }}>
                    <BranchGoogleMaps
                        values={values}
                        setValues={setValues}
                        inputErr={inputErr}
                        setInputErr={setInputErr}
                        inputRef={place_id_ref}
                        onAddressAutofill={handlePlaceAutofill}
                    />
                    <Divider textAlign="left" sx={{ my: 3, fontWeight: '600' }}>Información de la sucursal</Divider>
                    <Grid container spacing={4}>
                        <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
                            <img src={
                                    file ? URL.createObjectURL(file) : `${GOOGLE_DRIVE_CDN}${NO_IMG}`
                                } alt='imagen-sucursal' width='100%' height='300'
                                style={{ objectFit: 'contain', border: '1px solid #EAEDED' }}
                            />
                            <div style={{ marginTop: '10px' }}>
                                <input
                                    accept="image/*"
                                    type="file"
                                    id="select-image_suc"
                                    name="images"
                                    style={{ display: 'none' }} onChange={handleChange}
                                />
                                <label htmlFor="select-image_suc">
                                    <Button style={{ borderRadius: 0, textTransform: 'none' }} variant="contained" color="primary" component="span">
                                        Seleccionar imagen
                                    </Button>
                                </label>
                            </div>
                        </Grid>
                        <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
                            <BranchInfo
                                values={values}
                                setValues={setValues}
                                inputErr={inputErr}
                                sharedRefs={sharedRefs}
                                inputChange={inputChange}
                            />
                        </Grid>
                    </Grid>
                    <Divider textAlign="left" sx={{ my: 3, fontWeight: '600' }}>Dirección</Divider>
                    <Grid container spacing={2}>
                        <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                            <FormControl fullWidth>
                                <TextField
                                    variant='outlined'
                                    label='Calle'
                                    size='small'
                                    name='address'
                                    value={address}
                                    error={address_err}
                                    helperText={address_err ? "Ingrese la dirección de la sucursal" : ""}
                                    inputRef={address_ref}
                                    onChange={inputChange}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                            <FormControl fullWidth>
                                <TextField
                                    variant='outlined'
                                    label='Código postal'
                                    size='small'
                                    name='postalCode'
                                    value={postalCode}
                                    error={pc_err}
                                    helperText={pc_err ? "Ingrese el código postal de la sucursal" : ""}
                                    inputRef={postalCode_ref}
                                    onChange={inputChange}
                                    onBlur={handleInputBlur}
                                />
                            </FormControl>
                        </Grid>
                        {/* Colonia */}
                        {
                            (colonies.length === 0 || fieldType === 'field') ?
                                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <FormControl fullWidth>
                                        <TextField
                                            label="Colonia"
                                            size='small'
                                            name="colony"
                                            value={colony}
                                            error={colony_err}
                                            helperText={colony_err ? helperText : ""}
                                            onChange={inputChange}
                                        />
                                    </FormControl>
                                    <Link
                                        component="button"
                                        variant="body2"
                                        onClick={showAvailableFields}>
                                        Mostrarme la lista de colonias
                                    </Link>
                                </Grid>
                            :
                                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <FormControl fullWidth>
                                        <TextField
                                            size='small'
                                            name="colony"
                                            value={colony}
                                            error={colony_err}
                                            label="Colonia"
                                            select
                                            onChange={inputChange}
                                        >
                                            {
                                                colonies.map(({ nombre }) =>
                                                    <MenuItem key={nombre}
                                                        value={nombre}>{nombre}
                                                    </MenuItem>
                                                )
                                            }
                                        </TextField>
                                        {
                                            colony_err &&
                                            <FormHelperText 
                                                error={colony_err}>
                                                {helperText}
                                            </FormHelperText>
                                        }
                                    </FormControl>
                                    <Link
                                        component="button"
                                        variant="body2"
                                        onClick={() => setFieldType('field')}>
                                        Prefiero ingresar yo la colonia
                                    </Link>
                                </Grid>
                        }
                        <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                            <FormControl fullWidth>
                                <TextField
                                    variant='outlined'
                                    label='Ciudad'
                                    size='small'
                                    name='city'
                                    value={city}
                                    error={city_err}
                                    helperText={city_err ? "Ingrese la ciudad de la sucursal" : ""}
                                    inputRef={city_ref}
                                    disabled={cityInput}
                                    onChange={inputChange}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                            <FormControl fullWidth>
                                <TextField
                                    variant='outlined'
                                    label='Estado'
                                    size='small'
                                    name='state'
                                    value={state}
                                    error={state_err}
                                    helperText={state_err ? "Ingrese el estado de la sucursal" : ""}
                                    inputRef={state_ref}
                                    disabled={stateInput}
                                    onChange={inputChange}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Divider textAlign="left" sx={{ my: 3, fontWeight: 'bold' }}>Redes sociales</Divider>
                    <Grid container spacing={2}>
                        <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
                            <FormControl fullWidth>
                                <TextField
                                    variant='outlined'
                                    label='WhatsApp (número)'
                                    size='small'
                                    name='number'
                                    value={number}
                                    error={wsp_number_err}
                                    helperText={wsp_number_err ? "Ingrese el número de WhatsApp" : ""}
                                    inputRef={wsp_number_ref}
                                    onChange={inputChange}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
                            <FormControl fullWidth>
                                <TextField
                                    variant='outlined'
                                    label='Mensaje (Whatsapp)'
                                    size='small'
                                    name='message'
                                    value={message}
                                    error={wsp_message_err}
                                    helperText={wsp_message_err ? "Ingrese el mensaje de WhatsApp" : ""}
                                    inputRef={wsp_message_ref}
                                    onChange={inputChange}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
                            <FormControl fullWidth>
                                <TextField
                                    variant='outlined'
                                    label='Facebook (enlace)'
                                    size='small'
                                    name='url'
                                    value={url}
                                    // error={facebook_url_err}
                                    // helperText={facebook_url_err ? "Ingrese el url de facebook" : ""}
                                    inputRef={facebook_url_ref}
                                    onChange={inputChange}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                        {
                            loading ?
                                <LoadingButton
                                    loading
                                    loadingPosition="start"
                                    startIcon={<SaveIcon />}
                                    variant="outlined">
                                    Guardando
                                </LoadingButton>
                            :
                                <ButtonGreen variant='contained' onClick={ submit }>
                                    Crear nueva sucursal
                                </ButtonGreen>
                        }
                    </Box>
                </Box>

                <BranchFAB values={{ file, ...values }} />

                <BranchSnackbar
                    open={open}
                    setOpen={setOpen}
                    message={'No hay colonias disponibles'}
                />
            </Container>
        </>
    );
};

export default NewBranch;
